'use client';

import { sprinkles } from "./src/atomic/sprinkles.js";
function atomic(params) {
  return sprinkles(params);
}
export {
  atomic
};
